export enum DefaultFormats {
  DATE_FILTER = 'fr-CA',
}
